'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var $ = require("jquery");
var Form = /** @class */ (function () {
    function Form() {
        var _this = this;
        this.errorFlag = false;
        this.errorFlagArray = '';
        this.speed = 500;
        $('.trigCheckForm').on('click', function (e) {
            var firstErrorIndex = _this.getFirstErrorIndex();
            if (firstErrorIndex !== -1) {
                // フォーム処理中断
                e.preventDefault();
                // エラーメッセージまでの移動
                _this.scrollErrorMessage(firstErrorIndex);
            }
        });
    }
    // エラーのあった番号を取得
    Form.prototype.getFirstErrorIndex = function () {
        this.errorFlagArray = [];
        // フォームのエラーを配列に入れる
        this.errorFlagArray.push(this.checkType());
        this.errorFlagArray.push(this.checkName());
        this.errorFlagArray.push(this.checkNameKana());
        this.errorFlagArray.push(this.checkMail());
        this.errorFlagArray.push(this.checkTextarea());
        this.errorFlagArray.push(this.checkAccept());
        return $.inArray(true, this.errorFlagArray);
    };
    // お問い合わせ種類
    Form.prototype.checkType = function () {
        var radioVal = $('input[name="input_type"]:checked').val();
        if (radioVal === undefined) {
            this.errorFlag = true;
            $('.bulletErrorType').text('お問い合わせの種類を選んでください。');
            $('.bulletErrorType').css('display', 'block');
        }
        else {
            this.errorFlag = false;
            $('.bulletErrorType').text('');
            $('.bulletErrorType').css('display', 'none');
        }
        return this.errorFlag;
    };
    // お名前
    Form.prototype.checkName = function () {
        var nameVal = $('input[name="input_name"]').val();
        if (nameVal !== '') {
            this.errorFlag = false;
            $('.bulletErrorName').text('');
            $('.bulletErrorName').css('display', 'none');
        }
        else {
            this.errorFlag = true;
            $('.bulletErrorName').text('お名前を入力してください。');
            $('.bulletErrorName').css('display', 'block');
        }
        return this.errorFlag;
    };
    // フリガナ
    Form.prototype.checkNameKana = function () {
        var nameKanaVal = $('input[name="input_name_kana"]').val();
        if (nameKanaVal !== '') {
            if (this.isKana(nameKanaVal)) {
                this.errorFlag = false;
                $('.bulletErrorNameKana').text('');
                $('.bulletErrorNameKana').css('display', 'none');
            }
            else {
                this.errorFlag = true;
                $('.bulletErrorNameKana').text('カタカナで入力してください。');
                $('.bulletErrorNameKana').css('display', 'block');
            }
        }
        else {
            this.errorFlag = true;
            $('.bulletErrorNameKana').text('フリガナを入力してください。');
            $('.bulletErrorNameKana').css('display', 'block');
        }
        return this.errorFlag;
    };
    // メールアドレス
    Form.prototype.checkMail = function () {
        var mailVal = $('input[name="input_mail"]').val();
        var mailReVal = $('input[name="input_mail_re"]').val();
        if (mailVal !== '' || this.isAddress(mailVal)) {
            $('.bulletErrorMail').html('');
            $('.bulletErrorMail').css('display', 'none');
            this.errorFlag = false;
        }
        else {
            $('.bulletErrorMail').html('メールアドレスを入力してください。');
            $('.bulletErrorMail').css('display', 'block');
            this.errorFlag = true;
        }
        // 再入力
        if (mailReVal === '' || !this.isAddress(mailReVal)) {
            this.errorFlag = true;
            $('.bulletErrorMailRe').html('確認用メールアドレスを入力してください。');
            $('.bulletErrorMailRe').css('display', 'block');
        }
        else if (mailVal !== mailReVal) {
            this.errorFlag = true;
            $('.bulletErrorMailRe').text('メールアドレスが一致しません');
            $('.bulletErrorMailRe').css('display', 'block');
        }
        else {
            this.errorFlag = false;
            $('.bulletErrorMailRe').text('');
            $('.bulletErrorMailRe').css('display', 'none');
        }
        return this.errorFlag;
    };
    // お問い合わせ内容
    Form.prototype.checkTextarea = function () {
        var textareaVal = $('textarea[name="input_comment"]').val();
        if (textareaVal !== '') {
            this.errorFlag = false;
            $('.bulletErrorComment').text('');
            $('.bulletErrorComment').css('display', 'none');
        }
        else {
            this.errorFlag = true;
            $('.bulletErrorComment').text('お問い合わせ内容を入力してください。');
            $('.bulletErrorComment').css('display', 'block');
        }
        return this.errorFlag;
    };
    // 同意
    Form.prototype.checkAccept = function () {
        if ($('input[name="input_accept"]').prop('checked')) {
            this.errorFlag = false;
            $('.bulletErrorAccept').html('');
            $('.bulletErrorAccept').css('display', 'none');
        }
        else {
            this.errorFlag = true;
            $('.bulletErrorAccept').html('当社の個人情報保護に<br class="not-pc not-tab">同意頂く必要があります。');
            $('.bulletErrorAccept').css('display', 'block');
        }
        return this.errorFlag;
    };
    // 全角カナ、全角スペース、半角カナ、半角スペースならtrueを返す
    Form.prototype.isKana = function (str) {
        return !!str.match(/^[ァ-ヶー　ｦ-ﾟ ]*$/);
    };
    // メールアドレスの形式かどうか判定
    Form.prototype.isAddress = function (address) {
        var reg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
        if (reg.test(address)) {
            return true;
        }
        else {
            return false;
        }
    };
    // エラーメッセージ箇所までの移動
    Form.prototype.scrollErrorMessage = function (index) {
        var _this = this;
        var bullet = '.bulletScrollError_' + index;
        var position = $(bullet).offset().top;
        setTimeout(function () {
            var headerHeight = $('.paramHeader').outerHeight();
            // 移動実行
            $('html, body').animate({ scrollTop: position - headerHeight }, _this.speed);
        }, 100);
    };
    return Form;
}());
exports.Form = Form;
exports.default = Form;
